import React, { Component } from 'react';
import { ModalHeader, ModalFooter, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap'
import { MASTER_SECTION_TYPE, MASTER_TYPE } from '../constants';
import { validateCreateMasterKeyForm } from './helper';
import { toast } from 'react-toastify';
class CreateMasterData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            masterCreateForm: {
                name: '',
                apiKeyName:'',
                dataType: '',
                keyType: ''
            },
            apiKey: ''
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.initialValues !== prevProps.initialValues) {
            this.setState({
                masterCreateForm: this.props.initialValues
            })
        }
    }
    handleFormChange = (event) => {
        event.persist()
        switch (event.target.name) {
            case 'name':
                return this.setState((prevState) => ({
                    masterCreateForm: {
                        ...prevState.masterCreateForm,
                        name: event.target.value,
                    }
                }))
            case 'apiKey':
                return this.setState((prevState) => ({
                    masterCreateForm: {
                        ...prevState.masterCreateForm,
                        //snake case
                        apiKeyName: event.target.value.replaceAll(/[^a-zA-Z0-9]+/g, '_').toLowerCase()
                    },
                    apiKey: event.target.value
                }))
            case 'dataType':
                return this.setState((prevState) => ({
                    masterCreateForm: {
                        ...prevState.masterCreateForm,
                        dataType: event.target.value,
                    }
                }))
            case 'keyType':
                return this.setState((prevState) => ({
                    masterCreateForm: {
                        ...prevState.masterCreateForm,
                        keyType: event.target.value,
                    }
                }))
            default: return ''
        }
    }
    handleCreate = () => {
        if (validateCreateMasterKeyForm(this.state.masterCreateForm)) {
            this.props.createCallback(this.state.masterCreateForm)
        } else {
            toast.warning(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Enter all the required fields
                </div>
            );
        }

    }
    render() {
        const tempName = this.state.masterCreateForm.name
        return (
            <div>
                <ModalHeader>Create Master Key</ModalHeader>
                <ModalBody>
                    <Form onChange={this.handleFormChange}>
                        <FormGroup>
                            <Label for="name">Name <span className='text-danger'>*</span></Label>
                            <Input type="text" name="name" id="name" placeholder="Enter Master Key Name" />
                        </FormGroup>
                        <FormGroup>
                            <Label for="name">API Key <span className='text-danger'>*</span></Label>
                            <Input type="text" name="apiKey" id="apiKey" placeholder="Enter API Key" onBlur={(e) => {this.props.handleGetMasterKeys(this.state.masterCreateForm.apiKeyName)}   }/>
                            <Label className="text-muted ml-1">{(this.state.masterCreateForm.apiKeyName) ? "Will be create as : " + this.state.masterCreateForm.apiKeyName : ''}</Label>
                        </FormGroup>
                        <FormGroup>
                            <Label for="dataType">Data Type<span className='text-danger'>*</span></Label>
                            <Input type="select" name="dataType" id="dataType">
                                <option value=''>Select</option>
                                {
                                    MASTER_TYPE.map(p => {
                                        return (
                                            <option key={p}>{p}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="keyType">Key Type<span className='text-danger'>*</span></Label>
                            <Input type="select" name="keyType" id="keyType" >
                                <option value=''>Select</option>
                                {
                                    MASTER_SECTION_TYPE.map(p => {
                                        return (
                                            <option key={p}>{p}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.props.closeModal}>Close</Button>
                    <Button color="primary" onClick={this.handleCreate}>Add</Button>
                </ModalFooter>
            </div >
        )
    }
}

export default CreateMasterData